import {
  ANSWERS_STATS,
  ECM_STATUS,
  SURVEYS_BY_STAFF,
  SURVEYS_STATS,
} from "constants/endpoints";
import { get } from "services/network";
export const getSurveyStats = async (startDate, endDate) => {
  try {
    const result = await get(
      `${SURVEYS_STATS}?start_date=${startDate}&end_date=${endDate}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};
export const getAnswersStats = async (startDate, endDate) => {
  try {
    const result = await get(
      `${ANSWERS_STATS}?start_date=${startDate}&end_date=${endDate}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getEcmStatus = async (days) => {
  try {
    const result = await get(`${ECM_STATUS}?last_days=${days}`, true);
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getSurveyStaff = async (days) => {
  try {
    const result = await get(`${SURVEYS_BY_STAFF}?last_days=${days}`, true);
    return result;
  } catch (error) {
    console.log(error);
  }
};
